<template>
  <div>
    <el-dialog :visible.sync="isShowDetail" width="860px" title="订单详情" top="8vh" center>
      <div class="detail-container" v-loading.lock="fullscreenLoading" :class="{ banScroll: fullscreenLoading === true }">
        <div class="oilNum-wrapper">
          <div class="oilNum-title">
            <!-- <div class="title-color"></div> -->
            <div class="title-text">订单信息</div>
          </div>
          <!-- 船舶待支付订单信息 -->
          <template v-if="orderPayFlag === 0 && isShipStation">
            <div class="common">
              <div class="common_item">
                <div><span>订单号</span><span>{{orderInfo[0].orderId}}</span></div>
                <div><span>订单状态</span><span>{{orderInfo[0].orderPayFlagName}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>下单时间</span><span>{{orderInfo[0].orderDt| formatTime('YYYY-MM-DD HH:mm:ss', '--')}}</span></div>
                <div><span>油品单价</span><span>{{orderInfo[0].priceGun}}</span></div>
              </div>
            </div>
          </template>
          <!-- 油站订单信息 -->
          <template v-else>
            <div class="common">
              <div class="common_item">
                <div><span>订单号</span><span>{{orderInfo[0].orderId}}</span></div>
                <div><span>订单来源</span><span>{{orderInfo[0].orderType == '26' ? '团油（抖音原生核销）' : orderInfo[0].orderSourceName}}</span></div>
              </div>
              <div class="common_item">
                <div><span>下单时间</span><span>{{orderInfo[0].orderDt| formatTime('YYYY-MM-DD HH:mm:ss', '--')}}</span></div>
                <div><span>支付时间</span><span>{{orderInfo[0].payDt | formatTime('YYYY-MM-DD HH:mm:ss', '--')}}</span></div>
              </div>
              <div class="common_item">
                <div><span>支付方式</span><span>{{orderInfo[0].orderType == '26' ? '无支付订单' : orderInfo[0].payTypeName}}</span></div>
                <div><span>订单状态</span><span :class="[4, 5, 6].includes(orderPayFlag) ? 'change_color' : ''">{{orderInfo[0].orderPayFlagName}}</span></div>
              </div>
              <div class="common_item">
                <div><span>退款原因</span><span>{{orderInfo[0].refundReason}}</span></div>
                <!--退款中，退款失败，已取消不展示退款时间-->
                <div v-if="![4, 6, 7].includes(orderPayFlag)"><span>退款时间</span><span>{{orderInfo[0].refundDt | formatTime('YYYY-MM-DD HH:mm:ss', '--')}}</span></div>
              </div>
              <div class="common_item">
                <div><span>所属油站</span><span>{{orderInfo[0].gasName}}</span></div>
                <div v-if="orderInfo[0].showVerifyStatus"><span>核销状态</span><span>{{orderInfo[0].verificateStatusText}}</span></div>
              </div>
              <div class="common_item" v-if="orderInfo[0].showOilInvoiceStatusName">
                <div><span>开票状态</span><span>{{orderInfo[0].oilInvoiceStatusName}}</span></div>
                <div v-if="orderInfo[0].showVerifyStatus"><span>核销时间</span><span>{{orderInfo[0].verificateDate}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>开票方</span><span>{{orderInfo[0].invoiceFlagName}}</span></div>
              </div>
              <!--退款中，已退款, 已取消不展示-->
              <div class="common_item refund_reason ping_no" v-if="![4, 5, 7].includes(orderPayFlag)">
                <div><span>拒绝退款原因</span><span>{{orderInfo[0].cancelRefundContent}}</span></div>
              </div>
              <div class="common_item refund_reason" v-if="orderInfo[0].lastVoucherDirs.length > 0 && ![4, 5, 7].includes(orderPayFlag)">
                <div>
                  <span>凭证信息</span>
                  <span>
                      <!--上传视频和图片组件-->
                      <el-upload action="#" class="styleB" list-type="picture-card"  :on-preview='preview' :file-list="orderInfo[0].lastVoucherDirs">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="file" slot-scope="{file}">
                          <img
                            class="el-upload-list__item-thumbnail"
                            style="position: absolute"
                            :src="file.url" alt=""
                          >
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="preview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                  </span>
                </div>
              </div>
              <div class="common_item ping_no">
                <div><span>是否搭售非油品</span><span>{{orderInfo[0].nonOilOrderFlag == 1 ? '是' : '否'}}</span></div>
                <div><span>是否抖音小程序订单</span><span>{{orderInfo[0].orderType == 24 ? '是' : '否'}}</span></div>
              </div>
              <div class="common_item ping_no">
                <div><span>是否抖音模式结算</span><span>{{orderInfo[0].orderSettleType == 1 ? '是' : '否'}}</span></div>
                <div><span>是否抖音原生核销</span><span>{{ orderInfo[0].orderSettleType === -1001 ? '是' : '否' }}</span></div>
              </div>
              <div class="common_item ping_no">
                <div><span>是否快捷支付下单</span><span>{{orderInfo[0].isQuickPaymentOrder}}</span></div>
              </div>
            </div>
          </template>
        </div>

        <div class="oilNum-wrapper">
          <div class="oilNum-title">
            <div class="title-text">支付信息</div>
          </div>
          <!-- 船舶待支付订单支付信息 -->
          <template v-if="orderPayFlag === 0 && isShipStation">
            <div class="common">
              <div class="common_item">
                <div><span>加油金额</span><span>{{payInfo[0].amountGun}}</span></div>
                <div><span>油号</span><span>{{payInfo[0].oilNumName}}</span></div>
              </div>
              <div class="common_item">
                <div><span>枪号</span><span>{{payInfo[0].gunNo}}</span></div>
                <div><span>升数</span><span>{{payInfo[0].litre}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>吨数</span><span>{{payInfo[0].ton}}</span></div>
              </div>
            </div>
          </template>
          <!-- 油站订单支付信息 -->
          <template v-else>
            <div class="common">
              <div class="common_item">
                <div><span>{{isGas === 2 ? '金额' : '加油金额'}}</span><span>{{payInfo[0].amountGun}}</span></div>
                <div><span>让利金额</span><span>{{payInfo[0].rebate}}</span></div>
              </div>
              <div class="common_item">
                <div><span>{{isGas === 2 ? '气号' : '油品号'}}</span><span>{{payInfo[0].oilNumName}}</span></div>
                <div><span>{{isGas === 2 ? '数量' : '加油升数'}}</span><span>{{payInfo[0].litre}}</span></div>
              </div>
              <div class="common_item">
                <div><span>吨数</span><span>{{payInfo[0].ton}}</span></div>
                <div><span>油枪号</span><span>{{payInfo[0].gunNo}}</span></div>
              </div>
              <div class="common_item">
                <div><span>商家承担商家优惠券金额</span><span>{{payInfo[0].merchantCouponAmount}}</span></div>
                <div><span>商家承担直降金额</span><span>{{payInfo[0].activityAmountFromMt}}</span></div>
              </div>
              <div class="common_item">
                <div><span>商家承担平台优惠券金额</span><span>{{payInfo[0].pltCouponAmountFromMt}}</span></div>
                <div><span>随机免单金额</span><span>{{payInfo[0].randomFreeOrderAmount}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>会员储值卡编号</span><span>{{payInfo[0].gasVipCardNo}}</span></div>
                <div><span>会员储值卡扣款</span><span>{{payInfo[0].amountGasVipCard}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>商家优惠券来源</span><span>{{payInfo[0].merchantCouponType == 6006 ? '抖音商家售卖' : '其它'}}</span></div>
                <div><span>商家优惠券售卖金额</span><span>{{ handleAmount(payInfo[0].merchantCouponSaleAmount) }}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>抖音原生券金额</span><span>{{payInfo[0].orderMerchantCouponAmount}}</span></div>
                <div><span>抖音原生券售卖金额</span><span>{{payInfo[0].orderMerchantCouponSaleAmount}}</span></div>
              </div>
              <div class="common_item ping" v-if="showOilPayAmount === 1">
                <div><span>油品实付金额</span><span>{{payInfo[0].onlyOilPayAmount}}</span></div>
              </div>
            </div>
          </template>
        </div>

        <div class="oilNum-wrapper">
          <div class="oilNum-title">
            <div class="title-text">非油信息</div>
          </div>
          <template>
            <div class="common">
              <div class="common_item">
                <div><span>订单号</span><span>{{unOilInfo[0].nonOilOrderNo}}</span></div>
                <div><span>订单状态</span><span>{{unOilInfo[0].statusName}}</span></div>
              </div>
              <div class="common_item">
                <div><span>商品名称</span><span>{{unOilInfo[0].commodityName}}</span></div>
                <div><span>商品价格</span><span>{{unOilInfo[0].payAmount}}</span></div>
              </div>
              <div class="common_item ping">
                <div><span>商品规格</span><span>{{unOilInfo[0].commoditySpec}}</span></div>
              </div>
            </div>
          </template>
        </div>

        <div class="oilNum-wrapper">
          <div class="oilNum-title">
            <div v-if="orderPayFlag === 0 && isShipStation" class="title-text">用户信息</div>
            <div v-else class="title-text">司机信息</div>
          </div>
          <!-- 船舶待支付订单显示用户信息 -->
          <div class="common" v-if="orderPayFlag === 0 && isShipStation">
            <div class="common_item">
              <div><span>手机号码</span><span>{{driverInfo[0].phone | hidePhoneFourRank}}</span></div>
              <div><span>车队名称</span><span>{{driverInfo[0].channelName}}</span></div>
            </div>
          </div>
          <!-- 油站订单显示司机信息 -->
          <div class="common" v-else>
            <div class="common_item ping">
              <div><span>用户手机号</span><span>{{driverInfo[0].phone | hidePhoneFourRank}}</span></div>
              <div v-if="driverInfo[0].motorcadeName && driverInfo[0].motorcadeName !== '--'"><span>车队名称</span><span>{{driverInfo[0].motorcadeName}}</span></div>
              <div v-if="driverInfo[0].enterpriseServiceName && driverInfo[0].enterpriseServiceName !== '--'"><span>企服名称</span><span>{{driverInfo[0].enterpriseServiceName}}</span></div>
            </div>
          </div>
        </div>

        <div class="oilNum-wrapper" v-if="isShipStation">
          <div class="oilNum-title">
            <div class="title-text">预约信息</div>
          </div>
          <div class="common">
            <div class="common_item">
              <div><span>预约时间</span><span>{{orderMsg[0].reservationOrderDt}}</span></div>
              <div><span>预约加油量(吨)</span><span>{{orderMsg[0].reservationTon}}</span></div>
            </div>
            <div class="common_item ping">
              <div><span>船名</span><span>{{orderMsg[0].shipNumber}}</span></div>
              <div><span>MMSI</span><span>{{orderMsg[0].MMSI}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="detail_footer">
          <div class="on_order" @click="onOrNextorderidApi(1)"><span class="el-icon-arrow-left"></span>上一单</div>
          <div>
            <template  v-if="orderPayFlag === 1">
              <el-button class="confirm_btn_bu" size="mini" @click="showDoc(row.orderId)">补打小票</el-button>
              <!-- <el-button class="confirm_btn" v-if="show === 2" size="mini" @click="showRefund(row)">发起退款</el-button> -->
              <template v-if="row.show === 2">
                <!--一键退款和发起退款只能有一个,showOneClickRefund字段展示权限-->
                <el-button type="text" class="confirm_btn" v-if="row.showOneClickRefund" size="mini" @click="showRefund(row, 'one')">一键退款</el-button>
                <el-button type="text" class="confirm_btn" v-else size="mini" @click="showRefund(row)">发起退款</el-button>
              </template>
            </template>
            <template v-if="orderPayFlag === 4 && [1,3].includes(show)">
              <el-button :disabled="show === 3" size="mini" :class="[show === 3 ? '' : 'reject_btn']" @click="rejectRefund">拒绝退款</el-button>
              <el-button :disabled="show === 3" size="mini" :class="[show === 3 ? '' : 'confirm_btn']" @click="confirmRefund(row.refundReason)">确认退款</el-button>
            </template>
          </div>
          <div class="next_order" @click="onOrNextorderidApi(2)">下一单 <span class="el-icon-arrow-right"></span></div>
        </div>
      </span>
    </el-dialog>
    <!-- 补打小票提示 -->
    <ticket ref="ticket" :orderId="row.orderId" @handleChangeTicket="handleChangeTicket" />
      <!-- 确认退款组件 -->
    <confirmRefundDialog ref="confirmRefundDialog" :row="row" @handleConfirmRefund="handleConfirmRefund"/>
    <!--拒绝退款组件-->
    <rejectRefundDialog ref="rejectRefundDialog" :row="row" @handleRejectRefund="handleRejectRefund" @cancalReject="reset = false"/>
    <!--申请退款组件-->
    <applyRefundDialog ref="applyRefund" :row="row" @handleApply="handleApply"/>
    <!--预览-->
    <div class="pre">
      <el-dialog :visible.sync="dialogVisible" width="1100px" >
        <div class="preview">
          <div class="close_pre"><span @click="handleClosePre" class="el-icon-circle-close"></span></div>
          <video v-if="fileVideoUrl" ref="videoPlayer" controls :src="fileVideoUrl"  style="height: 100%; object-fit: fill"> </video>
          <img  v-else :src="dialogImageUrl" alt="">
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 0: "未支付" 1: "已支付" 4: "退款中" 5: "已退款" 6: "退款失败" 7: "已取消"
import ticket from './components/ticket'
import confirmRefundDialog from './components/confirmRefundDialog'
import rejectRefundDialog from './components/rejectRefundDialog'
import applyRefundDialog from './components/applyRefundDialog'
import { getOrderDetail, onOrNextorderid } from '@/api/order'
export default {
  name: 'orderDetail',
  props: ['isShipStation', 'isGas', 'orderOptions', 'address', 'showOilPayAmount'],
  data () {
    return {
      fullscreenLoading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      fileVideoUrl: '',
      row: {}, // 列表页传过来的列表每一项
      // flagsList: { // 订单状态列表
      //   1: '已支付',
      //   4: '退款中',
      //   5: '已退款',
      //   6: '退款失败'
      // },
      isShowDetail: false, // 详情弹框
      loading: false,
      orderInfo: [{
        orderId: '',
        orderDt: '',
        payDt: '',
        orderSourceName: '',
        payTypeName: '',
        orderPayFlagName: '',
        refundReason: '',
        nonOilOrderFlag: '',
        orderType: '',
        orderSettleType: '',
        refundDt: '',
        gasName: '',
        priceGun: '',
        verificateStatusText: '',
        verificateDate: '',
        showVerifyStatus: false,
        cancelRefundContent: '',
        lastVoucherDirs: [],
        oilInvoiceStatusName: '',
        invoiceFlagName: '',
        showOilInvoiceStatusName: false,
        isQuickPaymentOrder: ''
      }],
      payInfo: [{
        amountGun: 0,
        rebate: 0,
        oilNumName: '',
        gunNo: 0,
        litre: 0,
        ton: 0,
        merchantCouponAmount: 0, // 商家券
        activityAmountFromMt: 0,
        pltCouponAmountFromMt: 0,
        randomFreeOrderAmount: 0,
        gasVipCardNo: '',
        amountGasVipCard: '',
        couponSource: '',
        couponAmount: 0,
        merchantCouponSaleAmount: 0,
        merchantCouponType: '',
        orderMerchantCouponAmount: '',
        orderMerchantCouponSaleAmount: '',
        onlyOilPayAmount: ''
      }],
      unOilInfo: [{
        nonOilOrderNo: '',
        statusName: '',
        commodityName: '',
        payAmount: '',
        commoditySpec: ''
      }],
      driverInfo: [{
        phone: '',
        motorcadeName: '',
        enterpriseServiceName: ''
      }],
      orderMsg: [{
        shipNumber: '',
        mmsi: '',
        reservationTon: '',
        reservationOrderDt: ''
      }],
      orderPayFlag: null,
      show: '',
      reset: false
    }
  },
  components: {
    ticket,
    confirmRefundDialog,
    rejectRefundDialog,
    applyRefundDialog
  },
  methods: {
    initDia (row) {
      this.isShowDetail = true
      this.row = row
      this.init()
      this.getOrderDetail()
    },
    init () {
      this.orderInfo = [{
        orderId: '',
        orderDt: '',
        payDt: '',
        orderSourceName: '',
        payTypeName: '',
        orderPayFlagName: '',
        refundReason: '',
        nonOilOrderFlag: '',
        orderType: '',
        orderSettleType: '',
        refundDt: '',
        gasName: '',
        priceGun: '',
        verificateStatusText: '',
        verificateDate: '',
        showVerifyStatus: false,
        cancelRefundContent: '',
        lastVoucherDirs: [],
        oilInvoiceStatusName: '',
        invoiceFlagName: '',
        showOilInvoiceStatusName: false,
        isQuickPaymentOrder: ''
      }]
      this.payInfo = [{
        amountGun: 0,
        rebate: 0,
        oilNumName: '',
        gunNo: 0,
        litre: 0,
        ton: 0,
        merchantCouponAmount: 0,
        activityAmountFromMt: 0,
        pltCouponAmountFromMt: 0,
        randomFreeOrderAmount: 0,
        gasVipCardNo: '',
        amountGasVipCard: '',
        couponSource: '',
        couponAmount: 0,
        merchantCouponSaleAmount: 0,
        merchantCouponType: '',
        orderMerchantCouponAmount: '',
        orderMerchantCouponSaleAmount: '',
        onlyOilPayAmount: ''
      }]
      this.unOilInfo = [{
        nonOilOrderNo: '',
        statusName: '',
        commodityName: '',
        payAmount: '',
        commoditySpec: ''
      }]
      this.driverInfo = [{
        phone: '',
        motorcadeName: '',
        enterpriseServiceName: ''
      }]
      this.orderMsg = [{
        shipNumber: '',
        mmsi: '',
        reservationTon: '',
        reservationOrderDt: ''
      }]
    },
    preview (file) {
      this.dialogImageUrl = ''
      this.fileVideoUrl = ''
      this.dialogVisible = true
      // 获取后缀并且小写
      const fileExtension = file.url.split('?x-oss-process=video/snapshot,t_10000,m_fast')[0].toLowerCase()
      const isVideo = /^.*\.(mp4|mov)$/
      if (isVideo.test(fileExtension)) {
        const url = file.url.split('?x-oss-process=video/snapshot,t_10000,m_fast')[0]
        this.fileVideoUrl = url
      } else {
        this.dialogImageUrl = file.url
      }
    },
    handleClosePre () {
      this.dialogVisible = false
    },
    // 补打小票
    showDoc () {
      this.$refs.ticket.init()
    },
    // 补打小票成功组件方法
    handleChangeTicket () {
      this.getOrderDetail()
      this.$emit('handleDetailChange')
    },
    // 确认退款弹框按钮
    confirmRefund (reason) {
      this.$refs.confirmRefundDialog.init(reason)
    },
    // 确认弹框的组件方法
    handleConfirmRefund () {
      this.getOrderDetail()
      this.$emit('handleDetailChange')
    },
    // 拒绝退款弹窗按钮
    rejectRefund () {
      this.reset = true
      this.$nextTick(() => {
        this.$refs.rejectRefundDialog.init()
      })
    },
    // 拒绝退款弹框组件方法
    handleRejectRefund () {
      this.getOrderDetail()
      this.$emit('handleDetailChange')
    },
    // 申请退款弹框弹出按钮
    showRefund (row, flag) {
      this.$refs.applyRefund.init(row.orderId, flag)
    },
    // 申请退款弹框组件方法
    handleApply () {
      this.getOrderDetail()
      this.$emit('handleDetailChange')
    },
    // 上一单，下一单
    async onOrNextorderidApi (typePage) {
      this.fullscreenLoading = true;
      document.getElementsByClassName('detail-container')[0].scrollTop = 0;
      const params = {
        quickOperationSource: 1,
        placeAnOrderTime: this.row.orderDt,
        quickOperationType: typePage,
        cuurOrderId: this.orderInfo[0].orderId,
        ...this.orderOptions,
        ...this.address
      }
      try {
        const { code, result } = await onOrNextorderid(params)
        if (code !== 200) return
        if (result) {
          this.row = result
          this.getOrderDetail()
        } else {
          this.$message.error(typePage === 1 ? '没有上一单了' : '没有下一单了')
        }
        console.log(result, '上一单，下一单')
      } catch (error) {
        console.log(error)
      } finally {
        this.fullscreenLoading = false;
      }
    },
    // queren
    async getOrderDetail () {
      this.loading = true
      try {
        const { code, result } = await getOrderDetail({
          orderId: this.row.orderId
        })
        if (code !== 200) return
        let obj = {orderInfo: {...this.orderInfo[0]}, payInfo: {...this.payInfo[0]}, driverInfo: {...this.driverInfo[0]}, orderMsg: { ...this.orderMsg[0] }, unOilInfo: {...this.unOilInfo[0]}}
        for (let i in obj) {
          this[i].splice(0,1,this.setObj(obj[i], result))
        }
        // 处理视频图片返显
        if (result.lastVoucherDirs) {
          const listPic = result.lastVoucherDirs.split(',')
          this.orderInfo[0].lastVoucherDirs = []
          const isVideo = /^.*\.(mp4|mov)$/
          listPic.forEach((item, index) => {
            const fileExtension = item.substring(item.lastIndexOf('.')).toLowerCase()
            if (isVideo.test(fileExtension)) {
              item = `${item}?x-oss-process=video/snapshot,t_10000,m_fast`
            }
            this.orderInfo[0].lastVoucherDirs.push({ name: index, url: item })
          })
        } else {
          this.orderInfo[0].lastVoucherDirs = []
        }
        this.orderPayFlag = result.orderPayFlag
        this.show = result.show
        console.log('orderInfo=>', this.orderInfo[0])
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loading = false
      }
    },
    setObj (obj, result) {
      console.log(obj)
      for (let key in obj) {
        if (result[key] !== null) {
          obj[key] = result[key]
        } else {
          obj[key] = '--'
        }
      }
      return obj
    },
    handleAmount (amount) {
      console.log('amount', amount)
      if (!amount && amount !== 0) return '--'
      return amount
    }
  }
}
</script>

<style lang="less" scoped>
.detail-container{
  height: 650px;
  overflow-y: scroll;
}
.banScroll{
  height: 650px;
  overflow: hidden;
}
.common{
  width: 100%;
  // border: 1px solid #EBEEF5;
  border-right: 0;
  border-left: 0;
  .common_item{
    width: 100%;
    min-height: 40px;
    line-height: 22px;
    display: flex;
    justify-content: flex-start;
    border: 1px solid #EBEEF5;
    border-left: none;
    border-bottom: none;
    >div{
      width: 50%;
      min-height: 40px;
      display: flex;
      box-sizing:border-box;
      justify-content: flex-start;
       >span:nth-child(1){
        display: inline-block;
        width: 30%;
        min-height: 40px;
        background: #FAFAFA;
        border: 1px solid #EBEEF5;
        border-top: none;
        border-bottom: none;
        padding: 5px 0 5px 10px;
        display: flex;
        align-items: center;
      }
      >span:nth-child(2){
        width: 70%;
        min-height: 40px;
        padding-left: 10px;
        display: flex;
        align-items: center;
      }
    }
  }
  .ping{
    border-bottom: 1px solid #EBEEF5;
  }
  .ping_no{
    border-top: none;
    border-bottom: 1px solid #EBEEF5;
  }
  .refund_reason{
    >div{
      width: 100%;
      min-height: 40px;
      display: flex;
      box-sizing:border-box;
      justify-content: flex-start;
       >span:nth-child(1){
        display: inline-block;
        width: 15%;
        min-height: 40px;
        background: #FAFAFA;
        border: 1px solid #EBEEF5;
        border-top: none;
        border-bottom: none;
        padding-left: 10px;
        display: flex;
        align-items: center;
      }
      >span:nth-child(2){
        width: 85%;
        min-height: 40px;
        // border: 1px solid #EBEEF5;
        border-top: none;
        border-bottom: none;
        padding: 10px 0 10px 10px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.dialog{
  height: 680px;
}
/deep/ .el-dialog__header {
  background-color: #fff;
}
/deep/ .el-dialog__footer {
  height: 75px;
  box-shadow: 0px -2px 2px 0px #F4F7FC;
}
/deep/.el-dialog .el-dialog__body{
  padding: 10px 20px 5px 20px;
}
.detail_footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 62px;
}
.confirm_btn, .confirm_btn_bu{
  width: 90px;
  height: 40px;
  background: #4B7EFE;
  border-radius: 2px;
  // border: 1px solid #CCCCCC;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  border: none;
}
.confirm_btn_bu{
  width: 90px;
  height: 40px;
  background: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  border: 1px solid #CCCCCC;
}
.reject_btn{
  width: 90px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #CCCCCC;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.on_order{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  >span{
    color: #222222;
    font-weight: 600;
  }
}
.on_order:hover{
  color: #3377FF;
  >span{
    color: #3377FF;
    font-weight: 600;
  }
}
.next_order{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
   >span{
    color: #222222;
    font-weight: 600;
  }
}
.next_order:hover{
  color: #3377FF;
  >span{
    color: #3377FF;
    font-weight: 600;
  }
}
/deep/.styleB .el-upload--picture-card{
  display:none;   
}
.change_color{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #E73934;
}
.pre{
  /deep/.el-dialog__header{ 
    display: none;
  }
 /deep/.el-dialog__body{
    padding: 0;
  }
} 
.preview{
  padding: 5px 0;
  display: flex;
  width: 100%;
  justify-content: center;
  height: 650px;
  background: #fff;
  position: relative;
  .close_pre{
    width: 30px;
    height: 30px;
    top: 20px;
    right: 30px;
    position: absolute;
    >span{
      display: block;
      font-size: 30px;
      cursor: pointer;
    }
  }
}
@import url('./styles/detail.less');
</style>
